import { AssetType, DebtType } from "@fla/components";
import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "app/rootReducer";

import { ConsentOrdersState } from "./consentOrdersSlice";

function getConsentOrders(state: RootState): ConsentOrdersState {
  return state.consentOrders;
}

export const selectConsentOrdersBase = createSelector(getConsentOrders, co => co.base);

export const selectBaseAssetsDebts = createSelector(getConsentOrders, co => co.base.assetsDebts);

export const selectAssets = createSelector(getConsentOrders, co => co.assets);
export const selectDebts = createSelector(getConsentOrders, co => co.debts);

// export const selectAssetsDebtsStep = createSelector(getConsentOrders, co => co.assetsDebtsStep);
export const selectInitialDetailsStep = createSelector(getConsentOrders, co => co.initialDetailsStep);

export const selectAsset = (v: AssetType) =>
  createSelector(getConsentOrders, co => co.assets.filter(p => p.type === v) || []);

export const selectDebt = (v: DebtType) =>
  createSelector(getConsentOrders, co => co.debts.filter(p => p.type === v) || []);
